<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-toolbar-title class="ml-2 mt-2"
                    >Investimento</v-toolbar-title
                >
            </v-col>
        </v-row>
        <v-card class="mt-2 pt-4 px-2" elevation="1">
            <filtro ref="filtro" @filtrar="filtrar"></filtro>
        </v-card>
        <v-row no-gutters>
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
            >
                <v-card class="mt-4 px-2 pt-2" elevation="1">
                    <v-icon
                        style="
                            position: absolute;
                            top: 10px;
                            left: 10px;
                            z-index: 2;
                        "
                        left
                        :color="layoutCompacto ? 'primary' : ''"
                        @click="mudaLayout()"
                        title="Layout compacto"
                        >mdi-view-compact</v-icon
                    >
                    <highcharts
                        :options="graficoInvestimentoAno"
                        ref="grafico1"
                    ></highcharts>
                    <v-overlay :value="carregandoInvestimentoAno" absolute>
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
            >
                <v-card
                    class="mt-4 px-2 pt-2"
                    elevation="1"
                >
                    <v-icon
                        style="
                            position: absolute;
                            top: 10px;
                            left: 10px;
                            z-index: 2;
                        "
                        left
                        :color="layoutCompacto ? 'primary' : ''"
                        @click="mudaLayout()"
                        title="Layout compacto"
                        >mdi-view-compact</v-icon
                    >
                    <highcharts
                        :options="graficoInvestimentoMes"
                        ref="grafico2"
                    ></highcharts>
                    <v-overlay :value="carregandoInvestimentoMes" absolute>
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-col>
            <v-col
                v-for="(grafico, index) in topChartsToRender"
                :key="grafico.key"
                cols="12"
                sm="12"
                md="6"
                lg="6"
                xl="6"
            >
                <v-card
                    class="mt-4 px-2 pt-2"
                    :class="index % 2 === 1 ? 'ml-4' : ''"
                    elevation="1"
                >
                    <highcharts :options="grafico.options"></highcharts>
                    <v-overlay :value="grafico.loading" absolute>
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                    </v-overlay>
                    <v-card-actions class="justify-end pt-0 pb-1 px-0">
                        <v-menu offset-y left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="grafico.loading"
                                    aria-label="Exportar CSV"
                                >
                                    <v-icon small>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item @click="exportarTopCsv(grafico)">
                                    <v-list-item-title>Exportar CSV completo</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import Filtro from './Filtro.vue'

const VISAO_CONFIG = {
    pdv: {
        label: 'PDV',
        suffix: 'pdv',
        colorInvestimento: '#4ca15d',
        colorInvestimentoAnterior: '#0a2f2a',
        colorDesconto: '#d66e0f',
        colorDescontoAnterior: '#fffec7',
        colorTop: '#a89b91',
    },
    campanha: {
        label: 'Campanha',
        suffix: 'campanha',
        colorInvestimento: '#4ca15d',
        colorInvestimentoAnterior: '#0a2f2a',
        colorDesconto: '#d66e0f',
        colorDescontoAnterior: '#fffec7',
        colorTop: '#f4b36f',
    },
    ecommerce: {
        label: 'E-commerce',
        suffix: 'ecommerce',
        colorInvestimento: '#4ca15d',
        colorInvestimentoAnterior: '#0a2f2a',
        colorDesconto: '#d66e0f',
        colorDescontoAnterior: '#fffec7',
        colorTop: '#212121',
    },
    planejamento_ecommerce: {
        label: 'Planejamento E-commerce',
        suffix: 'planejamento_ecommerce',
        colorInvestimento: '#4ca15d',
        colorInvestimentoAnterior: '#0a2f2a',
        colorDesconto: '#d66e0f',
        colorDescontoAnterior: '#fffec7',
        colorTop: '#0a2f2a',
    },
}

function criarGraficoTopBase(titulo, cor) {
    return {
        credits: {
            enabled: false,
        },
        tooltip: {
            enabled: false,
        },
        title: {
            text: titulo,
        },
        chart: {
            type: 'bar',
        },
        yAxis: {
            visible: false,
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return this.point.y.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })
                    },
                    style: {
                        fontWeight: 'bold',
                        color: '#000',
                        textOutline: 'none',
                    },
                },
            },
        },
        xAxis: {
            categories: [],
        },
        series: [
            {
                data: [],
                color: cor,
            },
        ],
    }
}

export default {
    components: {
        Filtro,
    },
    data() {
        return {
            carregando: false,
            carregandoInvestimentoMes: false,
            carregandoInvestimentoAno: false,
            carregandoInvestimentoFornecedor: false,
            carregandoDesconto: false,
            visoesSelecionadas: ['pdv'],
            layoutCompacto: true,
            dadosInvestimentoFornecedor: [],
            dadosInvestimentoDesconto: [],
            ultimoFiltro: null,
            graficoInvestimentoMes: {
                credits: {
                    enabled: false,
                },
                custom: {
                    mostrarTagVisao: false,
                },
                tooltip: {
                    enabled: true,
                    useHTML: true,
                    formatter: function () {
                        const valor = this.point.y.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })
                        let categoria = `${this.x || ''}`

                        if (
                            this.series &&
                            this.series.name &&
                            this.series.name.includes('Ano Anterior')
                        ) {
                            const matchMesAno = categoria.match(/^(\d{2})\/(\d{4})$/)
                            if (matchMesAno) {
                                const mes = matchMesAno[1]
                                const anoAtual = Number(matchMesAno[2])
                                categoria = `${mes}/${anoAtual - 1}`
                            }
                        }

                        return `<b>${this.series.name}</b><br/>${categoria}: ${valor}`
                    },
                },
                legend: {
                    enabled: true,
                    alignColumns: true,
                    itemStyle: {
                        fontSize: '11px',
                    },
                },
                title: {
                    text: 'Investimento Mensal Comparativo',
                },
                subtitle: {
                    text: '',
                },
                chart: {
                    type: 'column',
                },
                yAxis: {
                    visible: true,
                    min: 0,
                    title: {
                        text: null,
                    },
                    labels: {
                        enabled: false,
                    },
                    gridLineWidth: 0,
                    lineWidth: 0,
                    tickLength: 0,
                    plotLines: [
                        {
                            value: 0,
                            color: '#ccd6eb',
                            width: 1,
                            zIndex: 5,
                        },
                    ],
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: false,
                            formatter: function () {
                                const valor = this.point.y.toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })
                                const mostrarTag =
                                    this.series.chart.options.custom &&
                                    this.series.chart.options.custom.mostrarTagVisao

                                if (!mostrarTag) {
                                    return valor
                                }

                                const sigla = this.series.userOptions.visaoSigla
                                return sigla ? `${sigla}\n${valor}` : valor
                            },
                            style: {
                                fontWeight: 'bold',
                                color: '#000',
                                textOutline: 'none',
                            },
                        },
                        states: {
                            inactive: {
                                opacity: 1,
                            },
                        },
                    },
                },
                xAxis: {
                    categories: [],
                    opposite: true,
                    lineWidth: 0,
                    tickLength: 0,
                    labels: {
                        enabled: true,
                    },
                },
                series: [],
            },
            graficoInvestimentoAno: {
                credits: {
                    enabled: false,
                },
                tooltip: {
                    enabled: false,
                },
                title: {
                    text: 'Investimento Anual Comparativo',
                },
                chart: {
                    type: 'column',
                },
                yAxis: {
                    visible: false,
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                return this.point.y.toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })
                            },
                            style: {
                                fontWeight: 'bold',
                                color: '#000',
                                textOutline: 'none',
                            },
                        },
                        states: {
                            inactive: {
                                opacity: 1,
                            },
                        },
                    },
                },
                xAxis: {
                    categories: [],
                },
                series: [],
            },
            graficosTopInvestimento: {
                pdv: criarGraficoTopBase('Top 10 Investimentos - PDV', VISAO_CONFIG.pdv.colorTop),
                campanha: criarGraficoTopBase('Top 10 Investimentos - Campanha', VISAO_CONFIG.campanha.colorTop),
                ecommerce: criarGraficoTopBase('Top 10 Investimentos - E-commerce', VISAO_CONFIG.ecommerce.colorTop),
                planejamento_ecommerce: criarGraficoTopBase('Top 10 Investimentos - Planejamento E-commerce', VISAO_CONFIG.planejamento_ecommerce.colorTop),
            },
            graficosTopDesconto: {
                pdv: criarGraficoTopBase('Top 10 Descontos - PDV', VISAO_CONFIG.pdv.colorTop),
                campanha: criarGraficoTopBase('Top 10 Descontos - Campanha', VISAO_CONFIG.campanha.colorTop),
                ecommerce: criarGraficoTopBase('Top 10 Descontos - E-commerce', VISAO_CONFIG.ecommerce.colorTop),
                planejamento_ecommerce: criarGraficoTopBase('Top 10 Descontos - Planejamento E-commerce', VISAO_CONFIG.planejamento_ecommerce.colorTop),
            },
        }
    },
    // provide() {
    //     return {
    //         listaCampos: this.listaCampos()
    //     }
    // },
    watch: {
        layoutComparativoExpandido() {
            this.reflowGraficosComparativos()
        },
    },
    computed: {
        layoutComparativoExpandido() {
            return this.visoesSelecionadas.length > 1
        },
        topChartsToRender() {
            const itens = []
            for (const visao of this.visoesSelecionadas) {
                if (!this.graficosTopInvestimento[visao] || !this.graficosTopDesconto[visao]) {
                    continue
                }
                itens.push({
                    key: `investimento-${visao}`,
                    tipo: 'investimento',
                    visao,
                    options: this.graficosTopInvestimento[visao],
                    loading: this.carregandoInvestimentoFornecedor,
                })
                itens.push({
                    key: `desconto-${visao}`,
                    tipo: 'desconto',
                    visao,
                    options: this.graficosTopDesconto[visao],
                    loading: this.carregandoDesconto,
                })
            }
            return itens
        },
    },
    methods: {
        atualizarLegendaMensalNativa() {
            if (!this.$refs.grafico2 || !this.$refs.grafico2.chart) {
                return
            }

            const chart = this.$refs.grafico2.chart
            const chartWidth = chart.chartWidth || 0
            const colunasLegenda = Math.max(this.visoesSelecionadas.length, 1)

            let itemWidth
            if (colunasLegenda > 1 && chartWidth > 240) {
                itemWidth = Math.floor((chartWidth - 40) / colunasLegenda)
            }

            chart.update(
                {
                    legend: {
                        enabled: true,
                        alignColumns: true,
                        itemWidth,
                        itemStyle: {
                            fontSize: '10px',
                        },
                    },
                },
                true,
                false
            )
        },
        reflowGraficosComparativos() {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.grafico1 && this.$refs.grafico1.chart) {
                        this.$refs.grafico1.chart.reflow()
                    }
                    if (this.$refs.grafico2 && this.$refs.grafico2.chart) {
                        this.$refs.grafico2.chart.reflow()
                    }
                    this.atualizarLegendaMensalNativa()
                }, 100)
            })
        },
        normalizarVisao(valor) {
            if (!valor) return null
            const texto = String(valor)
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '_')
                .replace(/-/g, '_')

            if (texto.includes('planejamento')) return 'planejamento_ecommerce'
            if (texto.includes('campanha')) return 'campanha'
            if (texto.includes('commerce')) return 'ecommerce'
            if (texto.includes('pdv')) return 'pdv'
            return null
        },
        normalizarVisoesSelecionadas(lista) {
            const visoes = Array.isArray(lista) ? lista : []
            const normalizadas = visoes
                .map((item) => this.normalizarVisao(item))
                .filter((item) => !!item)
            if (normalizadas.length === 0) {
                return ['pdv']
            }
            return [...new Set(normalizadas)]
        },
        montarSeriesMensalVisao(dados, visao) {
            const config = VISAO_CONFIG[visao]
            const sufixo = config.suffix
            const label = config.label
            const visaoSiglaMap = {
                pdv: 'PDV',
                campanha: 'CAMP.',
                ecommerce: 'E-COM',
                planejamento_ecommerce: 'PLAN.',
            }
            const visaoSigla = visaoSiglaMap[visao] || label

            const valorDaLinha = (linha, campo) => {
                if (linha == null) return 0
                if (linha[`${campo}_${sufixo}`] != null) return linha[`${campo}_${sufixo}`] * 1
                if (linha[sufixo] && linha[sufixo][campo] != null) return linha[sufixo][campo] * 1
                const visaoLinha = this.normalizarVisao(linha.visao)
                if (visaoLinha === visao && linha[campo] != null) return linha[campo] * 1
                if (visao === 'pdv' && !linha.visao && linha[campo] != null) return linha[campo] * 1
                return 0
            }

            return [
                {
                    name: `Investimento - ${label}`,
                    data: dados.map((linha) => valorDaLinha(linha, 'investimento')),
                    color: config.colorInvestimento,
                    visaoSigla,
                },
                {
                    name: `Investimento Ano Anterior - ${label}`,
                    data: dados.map((linha) => valorDaLinha(linha, 'investimento_anterior')),
                    color: config.colorInvestimentoAnterior,
                    visaoSigla,
                },
                {
                    name: `Desconto - ${label}`,
                    data: dados.map((linha) => valorDaLinha(linha, 'desconto')),
                    color: config.colorDesconto,
                    visaoSigla,
                },
                {
                    name: `Desconto Ano Anterior - ${label}`,
                    data: dados.map((linha) => valorDaLinha(linha, 'desconto_anterior')),
                    color: config.colorDescontoAnterior,
                    visaoSigla,
                },
            ]
        },
        montarSeriesMensalLegendaColunas(dados) {
            const blocosPorVisao = this.visoesSelecionadas.map((visao) =>
                this.montarSeriesMensalVisao(dados, visao)
            )

            return blocosPorVisao.flatMap((bloco, indiceVisao) =>
                bloco.map((serie, indiceMetrica) => ({
                    ...serie,
                    legendIndex: indiceMetrica * blocosPorVisao.length + indiceVisao,
                }))
            )
        },
        montarSeriesAnoVisao(dados, visao) {
            const config = VISAO_CONFIG[visao]
            const sufixo = config.suffix
            const label = config.label

            const valorDaLinha = (linha, campo) => {
                if (linha == null) return 0
                if (linha[`${campo}_${sufixo}`] != null) return linha[`${campo}_${sufixo}`] * 1
                if (linha[sufixo] && linha[sufixo][campo] != null) return linha[sufixo][campo] * 1
                const visaoLinha = this.normalizarVisao(linha.visao)
                if (visaoLinha === visao && linha[campo] != null) return linha[campo] * 1
                if (visao === 'pdv' && !linha.visao && linha[campo] != null) return linha[campo] * 1
                return 0
            }

            return [
                {
                    name: `Investimento - ${label}`,
                    data: dados.map((linha) => valorDaLinha(linha, 'investimento')),
                    color: config.colorInvestimento,
                },
                {
                    name: `Desconto - ${label}`,
                    data: dados.map((linha) => valorDaLinha(linha, 'desconto')),
                    color: config.colorDesconto,
                },
            ]
        },
        exportarTopCsv(grafico) {
            const visao = grafico?.visao
            const tipo = grafico?.tipo

            if (!visao || !tipo) {
                this.$dialog.notify.warning('Não foi possível identificar o gráfico para exportação.')
                return
            }

            const endpoint =
                tipo === 'investimento'
                    ? '/gerencial/exportarInvestimentoCompleto'
                    : '/gerencial/exportarDescontoCompleto'

            this.exportarCsvCompleto(endpoint, visao, tipo)
        },
        montarBodyExportacao(visao) {
            const filtroBase = this.ultimoFiltro || {}
            const visoes = Array.isArray(visao) ? visao : [visao]
            const { mesInicial, mesFinal, visao: visaoAtual, ...resto } = filtroBase

            const filtros = {}
            for (const [chave, valor] of Object.entries(resto)) {
                if (valor !== null && valor !== undefined && valor !== '') {
                    filtros[chave] = valor
                }
            }

            return {
                data: {
                    mesInicial,
                    mesFinal,
                    visao: visoes,
                    filtros,
                },
            }
        },
        async exportarCsvCompleto(endpoint, visao, tipo) {
            try {
                const response = await this.$http().post(
                    endpoint,
                    this.montarBodyExportacao(visao),
                    { responseType: 'blob' }
                )

                if (response?.status === 200 && response?.data) {
                    const nomeArquivo =
                        tipo === 'investimento'
                            ? `investimentos_completos_${visao}.csv`
                            : `descontos_completos_${visao}.csv`
                    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' })
                    const urlBlob = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = urlBlob
                    link.setAttribute('download', nomeArquivo)
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(urlBlob)

                    this.$dialog.notify.success('Arquivo CSV exportado com sucesso!')
                    return
                }

                this.$dialog.notify.error('Não foi possível exportar o CSV completo.')
            } catch (error) {
                console.error('Erro ao exportar CSV completo:', error)
                const mensagemErro =
                    error.response?.data?.msg ||
                    error.response?.data?.mensagem ||
                    'Erro ao exportar o CSV completo.'
                this.$dialog.notify.error(mensagemErro)
            }
        },
        agruparPorVisao(dados) {
            const grupos = {
                pdv: [],
                campanha: [],
                ecommerce: [],
                planejamento_ecommerce: [],
            }

            const lista = Array.isArray(dados) ? dados : []
            for (const item of lista) {
                const visaoItem = this.normalizarVisao(item.visao)
                if (visaoItem && grupos[visaoItem]) {
                    grupos[visaoItem].push(item)
                } else {
                    grupos.pdv.push(item)
                }
            }

            return grupos
        },
        limparGraficosTop() {
            for (const chave of Object.keys(this.graficosTopInvestimento)) {
                this.graficosTopInvestimento[chave].xAxis.categories = []
                this.graficosTopInvestimento[chave].series[0].data = []
                this.graficosTopDesconto[chave].xAxis.categories = []
                this.graficosTopDesconto[chave].series[0].data = []
            }
        },
        mudaLayout() {
            this.layoutCompacto = !this.layoutCompacto

            setTimeout(() => {
                this.$refs.grafico1.chart.reflow()
                this.$refs.grafico2.chart.reflow()
            }, 100)
        },
        // async listaCampos() {
        //     this.carregando = true

        //     var response = await this.$http().post('/gerencial/filtros', {})
        //     this.carregando = false
        //     return response.data
        // },
        async buscarInvestimentoMes(data) {
            this.carregandoInvestimentoMes = true

            var response = await this.$http().post(
                '/gerencial/investimentoMes',
                {
                    data: data,
                }
            )

            const dados = Array.isArray(response.data) ? response.data : []

            const categorias = dados.map((e) => e.mes)
            this.graficoInvestimentoMes.xAxis.categories = categorias
            this.graficoInvestimentoMes.subtitle.text = ''
            this.graficoInvestimentoMes.xAxis.labels.enabled = true

            const series = this.montarSeriesMensalLegendaColunas(dados)
            this.graficoInvestimentoMes.series = series
            this.atualizarLegendaMensalNativa()

            this.carregandoInvestimentoMes = false
            this.reflowGraficosComparativos()
        },
        async buscarInvestimentoAno(data) {
            this.carregandoInvestimentoAno = true

            var response = await this.$http().post(
                '/gerencial/investimentoAno',
                {
                    data: data,
                }
            )

            const dados = Array.isArray(response.data) ? response.data : []

            this.graficoInvestimentoAno.xAxis.categories = dados.map(
                (e) => e.ano
            )

            let series = []
            for (const visao of this.visoesSelecionadas) {
                series = [...series, ...this.montarSeriesAnoVisao(dados, visao)]
            }
            this.graficoInvestimentoAno.series = series

            this.carregandoInvestimentoAno = false
            this.reflowGraficosComparativos()
        },

        async buscarInvestimentoFornecedor(data) {
            this.carregandoInvestimentoFornecedor = true

            var response = await this.$http().post(
                '/gerencial/investimentoFornecedor',
                {
                    data: data,
                }
            )

            const dados = Array.isArray(response.data) ? response.data : []
            this.dadosInvestimentoFornecedor = dados
            const grupos = this.agruparPorVisao(dados)

            for (const visao of this.visoesSelecionadas) {
                const dadosVisao = grupos[visao] || []
                this.graficosTopInvestimento[visao].xAxis.categories = dadosVisao.map(
                    (e) => e.fornecedor
                )
                this.graficosTopInvestimento[visao].series[0].data = dadosVisao.map(
                    (e) => e.investimento * 1
                )
            }

            this.carregandoInvestimentoFornecedor = false
        },

        async buscarDesconto(data) {
            this.carregandoDesconto = true

            var response = await this.$http().post('/gerencial/investimentoDesconto', {
                data: data,
            })

            const dados = Array.isArray(response.data) ? response.data : []
            this.dadosInvestimentoDesconto = dados
            const grupos = this.agruparPorVisao(dados)

            for (const visao of this.visoesSelecionadas) {
                const dadosVisao = grupos[visao] || []
                this.graficosTopDesconto[visao].xAxis.categories = dadosVisao.map(
                    (e) => e.fornecedor
                )
                this.graficosTopDesconto[visao].series[0].data = dadosVisao.map(
                    (e) => e.desconto * 1
                )
            }

            this.carregandoDesconto = false
        },
        async filtrar() {
            // this.carregando = true

            if (this.$refs.filtro.filtro.mesInicial == undefined) {
                this.$refs.filtro.iniciaFiltro()
            }

            var filtro = { ...this.$refs.filtro.filtro }

            var data = {}

            data.mesInicial = filtro.mesInicial
            data.mesFinal = filtro.mesFinal
            data.visao = filtro.visao
            data.id_filial = filtro.id_filial
            data.bandeira = filtro.bandeira
            data.id_fornecedor = filtro.id_fornecedor
            data.id_macrofornecedor = filtro.id_macrofornecedor
            data.id_espaco = filtro.id_espaco
            data.espaco_macro = filtro.espaco_macro
            data.id_cluster = filtro.id_cluster
            data.categoria = filtro.categoria
            data.regiao = filtro.regiao
            data.perfil = filtro.perfil
            data.tamanho = filtro.tamanho

            this.ultimoFiltro = { ...data }

            this.visoesSelecionadas = this.normalizarVisoesSelecionadas(data.visao)
            this.graficoInvestimentoMes.custom.mostrarTagVisao =
                this.visoesSelecionadas.length > 1
            this.graficoInvestimentoMes.legend.enabled = true
            this.limparGraficosTop()

            this.buscarInvestimentoMes(data)
            this.buscarInvestimentoAno(data)
            this.buscarInvestimentoFornecedor(data)
            this.buscarDesconto(data)

            // var response = await this.$http().post('/gerencial/investimento', {data: data})

            // this.graficoInvestimentoMes.xAxis.categories = response.data.investimentoMes.map(e => e.mes)
            // this.graficoInvestimentoMes.series[0].data = response.data.investimentoMes.map(e => e.investimento*1)
            // this.graficoInvestimentoMes.series[1].data = response.data.investimentoMes.map(e => e.investimento_anterior*1)
            // this.graficoInvestimentoMes.series[2].data = response.data.investimentoMes.map(e => e.desconto*1)
            // this.graficoInvestimentoMes.series[3].data = response.data.investimentoMes.map(e => e.desconto_anterior*1)

            // this.graficoInvestimentoAno.xAxis.categories = response.data.investimentoAno.map(e => e.ano)
            // this.graficoInvestimentoAno.series[0].data = response.data.investimentoAno.map(e => e.investimento*1)
            // this.graficoInvestimentoAno.series[1].data = response.data.investimentoAno.map(e => e.desconto*1)

            // this.graficoInvestimento.xAxis.categories = response.data.fornecedorInvestimento.map(e => e.fornecedor)
            // this.graficoInvestimento.series[0].data = response.data.fornecedorInvestimento.map(e => e.investimento*1)

            // this.graficoDesconto.xAxis.categories = response.data.fornecedorDesconto.map(e => e.fornecedor)
            // this.graficoDesconto.series[0].data = response.data.fornecedorDesconto.map(e => e.desconto*1)

            // this.carregando = false
        },
    },
}
</script>


<style>
</style>